import { render } from "./Quiz.vue?vue&type=template&id=ace0a1a8&scoped=true"
import script from "./Quiz.vue?vue&type=script&lang=ts"
export * from "./Quiz.vue?vue&type=script&lang=ts"

import "./Quiz.vue?vue&type=style&index=0&id=ace0a1a8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ace0a1a8"

export default script